module.exports = __webpack_public_path__ + "img/loginLeft.d486fd96.png";